/* eslint-disable arrow-body-style */
import React from 'react';
import { getFormattedDate } from '@src/common/util/formatter';
import { Button } from '@abyss/web/ui/Button';
import { useRiskScoreResultsStore } from '../../../mothership/riskScoresResults.state';
import { RiskScoresPopoverBreakdown } from './RiskScoresPopupBreakdown';

export const RiskScoresTableBody = () => {
  const riskScoreTableData = useRiskScoreResultsStore(
    (state) => state.riskScoreTableData
  );
  return (
    <tbody data-cy="resultsTableBody" data-testid="resultsTableBody">
      {riskScoreTableData.map((row) => (
        <tr key={row.id}>
          <td>{row.matchedAccountValue}</td>
          <td>{row.riskThresholdName}</td>
          <td>
            <Button
              variant="tertiary"
              css={{
                'abyss-button-root': { padding: '0px', height: 'auto' },
              }}
            >
              <RiskScoresPopoverBreakdown
                signals={row.riskSignals}
                value={row.riskScore}
              />
            </Button>
          </td>
          <td>{getFormattedDate(row.lastActivityDateTime)}</td>
        </tr>
      ))}
    </tbody>
  );
};
